import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { PnsMacMiniUser } from 'interfaces/pns-mac-mini-user'

const fetchMacMiniUserDetail = async (
  userId: string
): Promise<PnsMacMiniUser> => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_mini_users/${userId}?include=all,appleIdConfig`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)

  return response.json()
}

const useMacMiniUserDetail = (userId: string) => {
  return useQuery(
    ['mac-mini-user-detail', userId],
    () => fetchMacMiniUserDetail(userId),
    {
      enabled: !!userId,
      staleTime: 30000,
      retry: 2,
    }
  )
}

export default useMacMiniUserDetail
